/* ============================================================
   KKingmart Mega Menu — header__mega-menu.js
   Upload to: assets/header__mega-menu.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Selectors ── */
  const TOGGLE_SEL   = '[data-mega-toggle]';
  const PANEL_SEL    = '[data-mega-panel]';
  const MOB_TOGGLE   = '[data-mobile-toggle]';
  const MOB_NAV_ID   = 'kkm-mobile-nav';
  const MOB_CLOSE_ID = 'kkm-mobile-close';
  const OVERLAY_ID   = 'kkm-overlay';

  /* ── State ── */
  let activePanel = null;
  let closeTimer  = null;

  /* ── Helpers ── */
  function openPanel(key) {
    if (activePanel === key) return;
    closeAllPanels();
    activePanel = key;

    const btn   = document.querySelector(`[data-mega-toggle="${key}"]`);
    const panel = document.querySelector(`[data-mega-panel="${key}"]`);
    if (!btn || !panel) return;

    btn.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('hidden');

    /* Force reflow so transition fires */
    panel.getBoundingClientRect();
    panel.style.opacity   = '1';
    panel.style.transform = 'translateY(0)';
    panel.style.pointerEvents = 'auto';
  }

  function closePanel(key) {
    const btn   = document.querySelector(`[data-mega-toggle="${key}"]`);
    const panel = document.querySelector(`[data-mega-panel="${key}"]`);
    if (!btn || !panel) return;

    btn.setAttribute('aria-expanded', 'false');
    panel.style.opacity   = '0';
    panel.style.transform = 'translateY(-8px)';
    panel.style.pointerEvents = 'none';

    /* Re-add hidden after transition */
    setTimeout(() => {
      if (panel.style.opacity === '0') {
        panel.setAttribute('hidden', '');
      }
    }, 200);

    if (activePanel === key) activePanel = null;
  }

  function closeAllPanels() {
    document.querySelectorAll(PANEL_SEL).forEach(panel => {
      const key = panel.dataset.megaPanel;
      closePanel(key);
    });
    activePanel = null;
  }

  /* ── Desktop mega toggle (hover + click) ── */
  document.querySelectorAll(`${TOGGLE_SEL}`).forEach(btn => {
    const key = btn.dataset.megaToggle;

    /* Hover: open on mouseenter */
    btn.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      openPanel(key);
    });

    /* Click: toggle */
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (activePanel === key) {
        closePanel(key);
      } else {
        openPanel(key);
      }
    });

    /* Keyboard: Enter / Space */
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (activePanel === key) {
          closePanel(key);
        } else {
          openPanel(key);
        }
      }
      if (e.key === 'Escape') {
        closePanel(key);
        btn.focus();
      }
    });

    /* Keep panel open when mouse enters it */
    const panel = document.querySelector(`[data-mega-panel="${key}"]`);
    if (panel) {
      panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
      panel.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => closePanel(key), 120);
      });
    }

    /* Close when mouse leaves the toggle button */
    btn.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => closePanel(key), 120);
    });
  });

  /* ── Close when clicking outside ── */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-mega-toggle]') && !e.target.closest('[data-mega-panel]')) {
      closeAllPanels();
    }
  });

  /* ── Close on Escape ── */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllPanels();
  });


  /* ══════════════════════════════════════
     MOBILE NAV
     ══════════════════════════════════════ */

  const mobileNav  = document.getElementById(MOB_NAV_ID);
  const closeBtn   = document.getElementById(MOB_CLOSE_ID);
  const overlay    = document.getElementById(OVERLAY_ID);

  /* Any element with [data-open-mobile-nav] triggers open */
  document.querySelectorAll('[data-open-mobile-nav]').forEach(trigger => {
    trigger.addEventListener('click', openMobileNav);
  });

  /* Hamburger button in theme header — common class names covered */
  const burgerSelectors = [
    '.header__icon--menu',
    '.js-mobile-nav-open',
    '[aria-label="Menu"]',
    '.mobile-nav-trigger',
    '.hamburger',
    '#mobile-nav-trigger'
  ];
  burgerSelectors.forEach(sel => {
    document.querySelectorAll(sel).forEach(el => {
      el.addEventListener('click', (e) => {
        /* Only hijack if it's a simple button, not a Shopify drawer trigger */
        if (!el.closest('[data-shopify-drawer]')) {
          e.preventDefault();
          openMobileNav();
        }
      });
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeMobileNav);
  if (overlay)  overlay.addEventListener('click', closeMobileNav);

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.style.display = 'block';
      requestAnimationFrame(() => overlay.classList.add('is-active'));
    }
    document.body.style.overflow = 'hidden';
    /* Focus first link */
    const first = mobileNav.querySelector('a, button');
    if (first) setTimeout(() => first.focus(), 310);
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (overlay) {
      overlay.classList.remove('is-active');
      setTimeout(() => { overlay.style.display = 'none'; }, 250);
    }
    document.body.style.overflow = '';
  }

  /* Mobile sub-menu accordion */
  document.querySelectorAll(MOB_TOGGLE).forEach(btn => {
    btn.addEventListener('click', () => {
      const targetId = btn.dataset.mobileToggle;
      const sub      = document.getElementById(targetId);
      const svg      = btn.querySelector('svg');
      if (!sub) return;

      const isOpen = !sub.hidden;
      sub.hidden   = isOpen;
      if (svg) svg.style.transform = isOpen ? '' : 'rotate(180deg)';
    });
  });

  /* Keyboard: Escape closes mobile nav */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) {
      closeMobileNav();
    }
  });

})();
